import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-afp-empresa',
  templateUrl: './add-afp-empresa.component.html',
  styleUrls: ['./add-afp-empresa.component.css']
})
export class AddAfpEmpresaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
